export enum FormInputAutocompleteOption {
    current = 'current-password', // NOTE: chrome only; FF converts this to 'off'
    default = 'on',
    new = 'new-password',
    off = 'off',
}
